import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import CategoryAddEditModal from './CategoryAddEditModal';

const CategoryAddEditModalBridge = react2angular(CategoryAddEditModal, [
  'categoryName',
  'description',
  'approverId',
  'flowModelEditors',
  'closeModal',
  'onCategoryChange'
]);
export default CategoryAddEditModalBridge;
